import actionCreator from '../../../utils/actionCreator';

const reviewsActionTypes = [
  'GET_REVIEWS',
  'REPORT_REVIEW',
];

export const { types: reviewsTypes, actions: reviewsActions } = actionCreator(reviewsActionTypes);
